import React from 'react';
import { useTranslate } from '@hooks';
import { toArray } from '@dotone/react-ui-core/utils';
import { FilterBlock, FilterList } from '@dotone/react-ui-core';
import { OfferFilterBlock } from '../filters';

const StatSummaryFilterList = ({ periodical = false, filters, reportType, ...otherProps }) => {
  const { t } = useTranslate('statSummary', 'model', { fallbackNs: 'stat' });

  const {
    dimension = 'offerId',
    startDate,
    endDate,
    offerIds = [],
    affiliateIds,
    imageCreativeIds,
    textCreativeIds,
  } = filters;

  return (
    <FilterList {...otherProps}>
      {!periodical && reportType !== 'performance' && (
        <FilterBlock
          list={false}
          label={t('statSummary:columnGroup.dimensions')}
          items={toArray(t(dimension))}
        />
      )}
      <FilterBlock list={false} label={t('common:from')} items={toArray(startDate)} />
      <FilterBlock list={false} label={t('common:to')} items={toArray(endDate)} />
      <OfferFilterBlock ids={offerIds} />
      <FilterBlock list={false} label={t('affiliateId')} items={toArray(affiliateIds)} />
      <FilterBlock list={false} label={t('imageCreativeId')} items={toArray(imageCreativeIds)} />
      <FilterBlock list={false} label={t('textCreativeId')} items={toArray(textCreativeIds)} />
    </FilterList>
  );
};

export default React.memo(StatSummaryFilterList);
